import React from "react";

const SKILL_ICONS = {
  "Agile/Scrum": "fas fa-people-arrows",
  "UI/UX Design": "fas fa-pen-ruler",
  "API Testing": "fas fa-vial",
  "Performance Optimization": "fas fa-gauge-high",
  "State Management": "fas fa-diagram-project",
  "Responsive Design": "fas fa-mobile-screen",
  "Version Control": "fas fa-code-branch",
  "Code Review": "fas fa-magnifying-glass",
  "Testing & QA": "fas fa-shield-halved",
  "Project Management": "fas fa-list-check",
  "Client Communication": "fas fa-comments",
  "Technical Writing": "fas fa-file-lines",
};

const AdditionalSkills = ({ skills, title, subtitle }) => (
  <div
    className="additional-skills additional-skills-v3"
    data-scroll-reveal="banner"
    style={{ "--reveal-delay": "0.2s" }}
  >
    <div className="additional-skills-v3-inner">
      <header className="additional-skills-v3-head">
        <span className="additional-skills-v3-badge" aria-hidden="true">
          <i className="fas fa-wand-magic-sparkles"></i>
        </span>
        <div>
          <h3>{title}</h3>
          {subtitle && <p>{subtitle}</p>}
        </div>
      </header>
      <div className="additional-skills-v3-tags">
        {skills.map((skill, index) => (
          <span
            key={skill}
            className="additional-skill-pill"
            style={{ "--pill-index": index }}
          >
            <i
              className={SKILL_ICONS[skill] || "fas fa-circle-check"}
              aria-hidden="true"
            ></i>
            {skill}
          </span>
        ))}
      </div>
    </div>
  </div>
);

export default AdditionalSkills;
